<template>
	<div class="nav">
		<router-link
			:aria-label="$t('WordscapesLevelPagePreviousButtonAriaLabel')"
			class="btn prev"
			:class="{ disabled: navCounter === minLevel }"
			:to="prevLink"
			@click.native="
				onBtnClick(
					`Click on Previous button ${$t(
						'WordscapesLevelPagePreviousButtonText'
					)}`
				)
			"
		>
			<div class="btn-content">
				<div class="text-and-icon">
					<span v-show="isSmallDevice" class="before-text">
						{{ prevBeforeText }}
					</span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						height="24"
						viewBox="0 0 24 24"
						width="24"
					>
						<path d="M0 0h24v24H0z" fill="none" />
						<path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z" />
					</svg>
				</div>
				<span class="after-text">
					{{ prevAfterText }}
				</span>
			</div>
		</router-link>
		<h1 v-html="navTitle" />
		<router-link
			:aria-label="$t('WordscapesLevelPageNextButtonAriaLabel')"
			:to="nextLink"
			:class="{ disabled: navCounter === maxLevel }"
			class="btn next"
			@click.native="
				onBtnClick(
					`Click on Next button ${$t(
						'WordscapesLevelPageNextButtonText'
					)}`
				)
			"
		>
			<div class="btn-content">
				<div class="text-and-icon">
					<span v-show="isSmallDevice" class="before-text">
						{{ nextBeforeText }}
					</span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						height="24"
						viewBox="0 0 24 24"
						width="24"
					>
						<path d="M0 0h24v24H0z" fill="none" />
						<path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z" />
					</svg>
				</div>
				<span class="after-text">
					{{ nextAfterText }}
				</span>
			</div>
		</router-link>
	</div>
</template>

<script>
import { capitalizeFirstLetter } from "@/common/functions";
import { mapState } from "vuex";

export default {
	name: "Board",
	props: {
		navCounter: {
			type: Number,
			required: true,
		},
	},
	computed: {
		...mapState(["minLevel", "maxLevel"]),
		navTitle() {
			const translation_value = this.$t("WordscapesLevelPageH1", {
				LevelNumber: this.$route.params.level,
				PackName: capitalizeFirstLetter(this.$route.params.pack),
				GroupName: capitalizeFirstLetter(this.$route.params.group),
			});

			return this.isSmallDevice
				? translation_value.replace("Wordscapes", "WS")
				: translation_value;
		},
		prevBeforeText() {
			return `PREV`;
		},
		prevAfterText() {
			return this.isSmallDevice
				? `Level ${this.navCounter - 1}`
				: `PREV: Level ${this.navCounter - 1}`;
		},
		prevLink() {
			return this.navCounter === this.minLevel
				? ""
				: { params: { level: this.navCounter - 1 } };
		},
		nextBeforeText() {
			return `NEXT`;
		},
		nextAfterText() {
			return this.isSmallDevice
				? `Level ${this.navCounter + 1}`
				: `NEXT: Level ${this.navCounter + 1}`;
		},
		nextLink() {
			return this.navCounter === this.maxLevel
				? ""
				: { params: { level: this.navCounter + 1 } };
		},
	},
	methods: {
		onBtnClick(eventAction) {
			this.$store.dispatch("trackEvent", {
				eventCategory: "Level page",
				eventAction: eventAction,
			});
		},
	},
};
</script>

<style lang="scss" scoped src="./styles.scss"></style>
